import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API from '../../config/apiconfig';
import { userLoginSuccess } from '../../action/userActions';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { userManagementApiLoader } from '../../action/loaderActions';
import { toast } from 'react-toastify';

export const useSignupInstance = () => {
  const [isErros, setIsErros] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  const signup = ({ email, name, mobile, password }) => {
    setIsErros([]);
    dispatch(userManagementApiLoader({isUsermanagementLoader: true}));
    const data = {
      "email": email,
      "name": name,
      "mobile": mobile,
      "password": password,
    };
    
    axios.post(
      `${API.USER_MANAGEMENT_API_BASE_URL}${API.USER_SIGNUP_URL}`,
      data,
      {
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
        },
      }
    )
    .then((response) => {
      console.log(response.data);
      
      // Show success toast
      const successMessage = response.data?.message || 'Signup successful! Please verify your account.';
      toast.success(successMessage, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      
      dispatch(userLoginSuccess({UserEmail: email}));
      dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
      navigate('/verify');
    })
    .catch((error) => {
      console.error('Error signing up:', error.response || error);
      dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
      
      // Handle error toast notifications
      if (error?.response?.data?.errors && Array.isArray(error.response.data.errors)) {
        // If there are multiple errors, show each one
        error.response.data.errors.forEach((errorMsg) => {
          toast.error(errorMsg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
        setIsErros(error.response.data.errors);
      } else if (error?.response?.data?.message) {
        // Single error message from API
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setIsErros([error.response.data.message]);
      } else if (error?.response?.status) {
        // Generic error based on status code
        const statusMessage = getStatusMessage(error.response.status);
        toast.error(statusMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setIsErros([statusMessage]);
      } else {
        // Network or unknown error
        toast.error('Something went wrong. Please try again.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setIsErros(['Something went wrong. Please try again.']);
      }
    });
  };

  // Helper function to get user-friendly error messages based on status codes
  const getStatusMessage = (status) => {
    switch (status) {
      case 400:
        return 'Invalid request. Please check your information.';
      case 401:
        return 'Unauthorized. Please check your credentials.';
      case 403:
        return 'Access forbidden.';
      case 409:
        return 'User already exists with this email.';
      case 422:
        return 'Validation error. Please check your input.';
      case 500:
        return 'Server error. Please try again later.';
      default:
        return `Error occurred (${status}). Please try again.`;
    }
  };
 
  return { signup, isErros };
};